import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import { ContentDiv, RowDiv, StyledP, TitleDiv } from "../styles";
import { FaPlus } from "react-icons/fa";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { TableDiv } from "./style";
import { t } from "i18next";
import { LabeledAutoComplete } from "../../../UI/LabeledAutoComplete";
import { ChangeEvent, useState } from "react";

export function Permissions() {
  const [input, setInput] = useState("");

  return (
    <>
      <ContentDiv style={{ width: "100%", margin: "auto" }}>
        <span style={{ fontSize: 13, color: "#222222", marginBottom: 4 }}>
          Projetos
        </span>
        <LabeledAutoComplete
          multiple
          options={[{ label: "Todas", value: "ALL" }]}
          inputValue={input}
          value={[{ label: "Todas", value: "ALL" }]}
          disablePortal
          getOptionLabel={(option) => option.label || ""}
          size="small"
          label=""
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                onChange={(
                  e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                ) => {
                  setInput(e.target.value);
                }}
              />
            );
          }}
        />

        {/* <FormGroup>
          <InputLabel>Projetos</InputLabel>
          <FormControlLabel
            control={<Switch checked={true} onChange={() => {}} />}
            label="Todos"
          />
        </FormGroup>
        <br />
        <FormGroup>
          <InputLabel>Visão clientes</InputLabel>

          <FormControlLabel
            control={<Switch checked={true} onChange={() => {}} />}
            label="Todos"
          />
        </FormGroup> */}
      </ContentDiv>
      <ContentDiv style={{ width: "100%", margin: "auto", marginTop: 16 }}>
        <span style={{ fontSize: 13, color: "#222222", marginBottom: 4 }}>
          Visão clientes
        </span>
        <LabeledAutoComplete
          multiple
          options={[{ label: "Todas", value: "ALL" }]}
          inputValue={input}
          value={[{ label: "Todas", value: "ALL" }]}
          disablePortal
          getOptionLabel={(option) => option.label || ""}
          size="small"
          label=""
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                onChange={(
                  e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                ) => {
                  setInput(e.target.value);
                }}
              />
            );
          }}
        />
      </ContentDiv>
    </>
  );
}
